import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import SoftTokensActivateTokenActivationPage, { getDefaultData } from "components/pages/SoftTokensActivateTokenActivationPage";

/**
 * @name CaptureSoftTokenActivationActivateTokenSignature
 * @returns {React.Component}
 * @description A capture component in the capture group "Soft Tokens - Activation".
 */
export default function CaptureSoftTokenActivationActivateTokenSignature(props) {
    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "activationSignature" ], { value: "" })
    .submit();

    return <SoftTokensActivateTokenActivationPage data={ data } />;
}